import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


function ProductDetailAccordion() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);

  return (
    <>
      <Box
        sx={{
          width: {
            xs: '100%',
            sm: '100%',
          },
          ml: {
            xs: 0,
            sm: 0,
          },
          mr: {
            xs: 0,
            sm: 0,
          },
          maxWidth: {
            md: '400px',
            lg: '500px',
          },
        }}
      >
        <Accordion sx={{
          mb: 2,
          background: "#F5F5F5",
          border: "1px solid #E4C18F",
          // boxShadow: '0 8px 16px rgba(0,0,0,0.10)',
          boxShadow: "none",
          borderRadius: "10px !important",
          overflow: "hidden",
          "&:before": {
            display: "none",
          },
          "&:first-of-type": {
            borderRadius: "10px !important",
          },
          "&:last-of-type": {
            borderRadius: "10px !important",
          },
          '& .MuiSvgIcon-root': {
            color: 'white',
            fontSize: 22,
          },
        }}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            sx={{
              minHeight: "48px !important",

              "& .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              "&.Mui-expanded": {
                minHeight: "48px !important",
              },

              "&.Mui-expanded .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              '& .MuiAccordionSummary-expandIconWrapper': {
                backgroundColor: '#E4C18F',
                color: 'primary.main',
                borderRadius: '50%',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
            }}
          >
            <Typography component="span"
              sx={{
                color: "#000000",
                fontSize: { xs: "13px", md: "14px", lg: "16px" },
                fontWeight: 500,
                fontFamily: "Be Vietnam Pro",

              }}>How To Redeem</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                fontFamily: "Be Vietnam Pro",
                fontSize: "13px",
                lineHeight: 2,

                "& p": { margin: 0 },
                "& ul, & ol": { paddingLeft: "20px" },
                "& li": { marginBottom: "6px" },
              }}
              dangerouslySetInnerHTML={{
                __html: PRODUCTDETAILS?.redemptionInfo || "",
              }}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            background: "#F5F5F5",
            border: "1px solid #E4C18F",
            borderRadius: "10px !important",
            overflow: "hidden",
            // boxShadow: '0 8px 16px rgba(0,0,0,0.10)',
            boxShadow: "none",
            "&:before": {
              display: "none",
            },
            "&:first-of-type": {
              borderRadius: "10px !important",
            },
            "&:last-of-type": {
              borderRadius: "10px !important",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              '& .MuiAccordionSummary-expandIconWrapper': {
               backgroundColor: '#E4C18F',
                color: 'primary.main',

                borderRadius: '50%',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
              '& .MuiSvgIcon-root': {
                color: 'white',
                fontSize: 22,
              },
            }}
          >
            <Typography component="span"
              sx={{
                color: "#000000",
                fontSize: { xs: "13px", md: "14px", lg: "16px" },
                fontWeight: 500,
                fontFamily: "Be Vietnam Pro"
              }}>Term & conditions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                fontFamily: "Be Vietnam Pro",
                fontSize: "13px",
                lineHeight: 2,

                "& p": { margin: 0 },
                "& ul, & ol": { paddingLeft: "20px" },
                "& li": { marginBottom: "6px" },
              }}
              dangerouslySetInnerHTML={{
                __html: PRODUCTDETAILS?.tnc || "",
              }}
            />
          </AccordionDetails>
        </Accordion>
      </Box >
    </>
  )
}

export default ProductDetailAccordion